import React from "react";
import {createRoot} from "react-dom/client";
import store from "./redux/index";
import General from "./general/index";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {Provider} from "react-redux";

const rootDom = document.createElement("div");
rootDom.classList.add("root")
document.body.appendChild(rootDom);

const root = createRoot(rootDom);

root.render(<Application/>);

const theme = createTheme({
    typography:{
        fontFamily: "ubuntu"
    }
});

function Application()
{
    return <Provider store={store}>
        <ThemeProvider theme={theme}>
            <General />
        </ThemeProvider>
    </Provider>
}